import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface AuthUser {
  _id?: string;
  name?: string;
  email?: string;
  role_name?: string;
  first_login?: boolean;
}

export interface AuthApiResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    user?: AuthUser;
    token?: string;
  };
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface VerifyOtpPayload {
  email: string;
  otp: string;
}

export interface ForgotPasswordPayload {
  email: string;
}

export interface ResetPasswordPayload {
  email: string;
  password: string;
  confirm_password: string;
}

export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

export interface ForceChangePasswordPayload {
  new_password: string;
  confirm_password: string;
}

export const login = async (payload: LoginPayload): Promise<AuthApiResponse> => {
  return api.post<AuthApiResponse, LoginPayload>(API_ENDPOINTS.auth.login, payload);
};

export const verifyOtp = async (payload: VerifyOtpPayload): Promise<AuthApiResponse> => {
  return api.post<AuthApiResponse, VerifyOtpPayload>(API_ENDPOINTS.auth.verifyOtp, payload);
};

export const forgotPassword = async (payload: ForgotPasswordPayload): Promise<AuthApiResponse> => {
  return api.post<AuthApiResponse, ForgotPasswordPayload>(API_ENDPOINTS.auth.forgotPassword, payload);
};

export const resetPassword = async (payload: ResetPasswordPayload): Promise<AuthApiResponse> => {
  return api.post<AuthApiResponse, ResetPasswordPayload>(API_ENDPOINTS.auth.resetPassword, payload);
};

export const changePassword = async (payload: ChangePasswordPayload): Promise<AuthApiResponse> => {
  return api.post<AuthApiResponse, ChangePasswordPayload>(API_ENDPOINTS.auth.changePassword, payload);
};

export const forceChangePassword = async (payload: ForceChangePasswordPayload): Promise<AuthApiResponse> => {
  return api.post<AuthApiResponse, ForceChangePasswordPayload>(API_ENDPOINTS.auth.forceChangePassword, payload);
};
